module.exports = __webpack_public_path__ + "static/media/10.0a6ade9c.jpg";